export class MenuBinding {
  /** The list of menu items to bind to. */
  public menuItems = "<?";

  /** If set to true, the submenu will be aligned to the right side of the main menu */
  public submenuRightAligned = "<?";
}

export interface MenuItem {
  /** The displayName for this menu item */
  displayName: string;

  /** Array that contains submenu items */
  subItems?: MenuItem[];

  /** Set this glyph class if you want a icon with this item*/
  glyph?: string;

  /** Callback triggered when an item is clicked on */
  onClick?: () => void;

  /** Callback triggered when key down is pressed for menu item*/
  onKeydown?: (event: KeyboardEvent) => void;
}
export class MenuController {
  public menuItems: MenuItem[];
  private awayMenuItemClass: string = "sd-menu-item sd-glyph-agent-away";
  // @ngInject
  constructor(private $rootScope: ng.IRootScopeService) {
    $rootScope.$on("OnClickStatusMenu", () => {
      if (document.getElementById("ulSubMenu")) {
        angular.element(document.getElementById("ulSubMenu")).removeAttr("style");
      }
      setTimeout(function (): void {
        angular.element(document.getElementsByTagName("sd-profile-card").item(0)).focus();
      }, 100);
    });
    $rootScope.$on("OnKeydownStatusMenu", () => {
      if (document.getElementById("ulSubMenu")) {
        angular.element(document.getElementById("ulSubMenu")).css("display", "block");
      }
      setTimeout(function (): void {
        if (
          document.getElementsByClassName(this.awayMenuItemClass) &&
          document.getElementsByClassName(this.awayMenuItemClass).length > 0
        ) {
          angular.element(document.getElementsByClassName(this.awayMenuItemClass).item(1)).focus();
        }
      }, 100);
    });
    $rootScope.$on("OnClickMeetingMenu", () => {
      if (document.getElementById("ulSubMenu")) {
        angular.element(document.getElementById("ulSubMenu")).removeAttr("style");
      }
    });
  }
}

export const sdMenu: ng.IComponentOptions = {
  controller: MenuController,
  templateUrl: "../ShellCommon/Controls/poppable-menu/menu.html",
  bindings: <any>new MenuBinding()
};
